<template>
  <div class="cars">
    <div class="row h-100 m-0 p-0">
      <div :class="'p-0 ' + (isOrientationPortrait ? 'h-50 col-12' : 'h-100 col-8')">
        <cars-map
          ref="map"
          :cities="cities"
          :models="models"
          :car-markers="carMarkers"
          @changeCity="changeCity"
        />
      </div>
      <div :class="'p-0 overflow-scroll-y ' + (isOrientationPortrait ? 'h-50 col-12' : 'h-100 col-4')">
        <ui-loader v-if="loading" />
        <ul class="list-group" v-else-if="filteredCars.length > 0">
          <li class="list-group-item py-3 rounded-0" v-for="(car, i) in filteredCars" :key="i">
              <div class="row" :style="car.available ? '' : 'opacity: 0.3'">
                  <div class="col-3 text-center">
                      <img v-if="car.thumbnailUrl" :src="car.thumbnailUrl" style="width: 100%" />
                  </div>
                  <div class="col-9">
                    <h5 class="mb-0">
                      <span class="badge rounded-1 px-1 text-bg-success">{{ car.number }}</span>
                      {{ car.modelName }}
                      <button v-if="car.available" class="btn btn-sm border-0 position-relative p-0" @click="locateCar(car)" style="font-size: 20px; top: -2px">
                        <fa-icon icon="fa-solid fa-crosshairs" />
                      </button>
                    </h5>
                    <div class="mb-1">
                      <span class="tag px-2 rounded-1">VIN: {{ car.vin }}</span>
                      <span class="tag px-2 rounded-1 ms-1" v-if="car.regNumber">{{ car.regNumber }}</span>
                    </div>
                    <div class="small">
                      <span><fa-icon icon="fa-gas-pump" /> {{ car.fuel }}% (~{{ car.range }}km)</span>
                      <span v-if="car.location" class="small ms-2"><fa-icon icon="fa-location-dot" /> {{ car.location }}</span>
                      <span v-if="car.discount" class="small ms-2 badge badge-promo rounded-1 px-1 text-bg-success text-start"><fa-icon icon="fa-gift" /> +{{ car.discount }} zł</span>
                    </div>
                  </div>
              </div>
          </li>
        </ul>
        <div v-else class="p-3 text-center">
          Brak samochodów do wyświetlenia.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarsMap from "@/components/Cars/CarsMap.vue";
import {mapActions, mapGetters} from "vuex";
// import UiModal from "@/components/Ui/UiModal.vue";
import UiLoader from "@/components/Ui/UiLoader.vue";
import {default as api} from '@/services/api';
import searcher from "@/store/search";

export default {
  name: 'CarsView',
  components: {
    UiLoader,
    // UiModal,
    CarsMap
  },
  computed: {
    ...mapGetters({
      isOrientationPortrait: 'device/isOrientationPortrait',
      currentCity: 'map/getCity',
      currentModels: 'map/getModels',
    }),
    carMarkers() {
      let markers = {};
      for (const city of this.cities) {
        markers[city.id] = [];
      }
      for (const car of this.cars) {
        if (!car.available) {
          continue;
        }
        markers[car.cityId].push(car);
      }
      return markers;
    },
    filteredCars() {
      return this.cars.filter((car) => {
        if (!searcher.search) {
          if (this.currentCity && car.cityId !== this.currentCity) {
            return false;
          }
          return this.currentModels.includes(car.modelId);
        }

        const pattern = new RegExp(searcher.search, 'i');

        return car.vin.match(pattern) || car.number.toString().match(pattern) || car.regNumber.match(pattern);
      });
    }
  },
  data() {
    return {
      carContext: null,
      cars: [],
      cities: [],
      models: [],
      loading: true,
    }
  },
  mounted() {
    this.loadCars();
  },
  methods: {
    ...mapActions({
      setCity: 'map/setCity',
      setModels: 'map/setModels',
    }),
    async loadCars() {
      this.loading = true;

      const data = await api.getCars();
      this.cities = data.cities || [];
      this.models = data.models || [];

      const models = {};
      for (const model of this.models) {
        models[model.externalId] = model;
      }

      const cities = {};
      for (const city of this.cities) {
        city.count = 0;
        cities[city.id] = city;
      }

      this.cars = (data.cars || []).map((car) => {
        const model = models[car.modelId] ?? null;
        if (model) {
          car.modelName = model.name;
          car.thumbnailUrl = model.frontImageUrl;
          car.location = cities[car.cityId].name || '';
        }
        if (car.available) {
          cities[car.cityId].count++;
        }
        return car;
      });

      if (!this.currentModels.length) {
        this.setModels(Object.keys(models).map(m => parseInt(m)));
      }

      if (!this.currentCity) {
        const cityId = Object.values(cities).find(c => c.name === 'Poznań').id;
        this.setCity(cityId);
        this.changeCity(cityId);
      }

      this.loading = false;
    },
    changeCity(cityId) {
      const coordinate = this.cities.find(c => c.id === cityId).coordinate;
      this.$refs.map.changePosition(coordinate.latitude, coordinate.longitude);
    },
    locateCar(car) {
      this.$refs.map.locateCar(car);
    }
  }
}
</script>

<style lang="scss" scoped>
.cars {
  height: calc(100vh - 64px);
  position: relative;
  overflow: hidden;
  .list-group-item {
    background-size: auto;
    background-position: center center;
    background-repeat: no-repeat;
    background: #ffffff;
    background: linear-gradient(180deg, #ffffff 0%, #f4f4f4 35%, #ddd 100%);
    border: none;
    border-bottom: 1px solid #aaa;
    .badge {
      width: 65px;
      color: #fff;
      &.badge-promo {
        width: auto;
      }
    }
    .tag {
      border: 1px solid #999;
      color: #999;
      font-size: 11px;
      padding: 2px;
      a {
        color: inherit;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    h5 {
      font-weight: 600;
      color: #333;
    }
  }
}
</style>
